
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProjectInfo,
} from '../models';
import {
    ProjectInfoFromJSON,
    ProjectInfoToJSON,
} from '../models';

export interface GetProjectInfoRequest {
    projectId: string;
}

/**
 * 
 */
export class ProjectApi extends runtime.BaseAPI {

    /**
     * Retrieve project info
          */
    async getProjectInfoRaw(requestParameters: GetProjectInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectInfo>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectInfo>({
            path: `/profile/api/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectInfoFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve project info
          */
    async getProjectInfo(requestParameters: GetProjectInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectInfo> {
        const response = await this.getProjectInfoRaw(requestParameters, initOverrides);
        return response._data;
    }

}
